import { render, staticRenderFns } from "./decline-claim-review.vue?vue&type=template&id=031c9474&"
import script from "./decline-claim-review.vue?vue&type=script&lang=js&"
export * from "./decline-claim-review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports